export default "__VITE_ASSET__Bsc_qjJa__"